import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonPadraoComponent } from '../../shared/components/button-padrao/button-padrao.component';
import { SelectOneComponent } from '../../shared/components/select-one/select-one.component';
import { IdNome } from '../../shared/model/id-nome.model';
import { SetorService } from '../../shared/service/setor.service';
import { PerfilService } from '../../shared/service/perfil.service';
import { AuthService } from '../../shared/service/auth.service';

@Component({
  selector: 'app-modal-filtro-usuario',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    SelectOneComponent
  ],
  templateUrl: './modal-filtro-usuario.component.html',
  styleUrl: './modal-filtro-usuario.component.css'
})
export class ModalFiltroUsuarioComponent implements OnInit {
  setores: IdNome[] = [];
  perfis: IdNome[] = [];

  readonly statusOpcoes: IdNome[] = [
    { id: 1, nome: 'Ativo' },
    { id: 0, nome: 'Inativo' },
    { id: -1, nome: 'Todos' }
  ];

  filtro: { setor?: IdNome, perfil?: IdNome, status?: IdNome } = { status: this.statusOpcoes[0] };

  constructor(
    private dialog: MatDialogRef<ModalFiltroUsuarioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private setorService: SetorService,
    private perfilService: PerfilService,
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.filtro = { status: this.statusOpcoes[0], ...(this.data?.filtro ?? {}) };
    this.buscarSetores();
    this.buscarPerfis();
  }

  buscarSetores() {
    this.setorService.buscarSetoresSelectAtivo().subscribe({
      next: res => this.setores = res
    });
  }

  buscarPerfis() {
    this.perfilService.buscarPerfilSelectDoGrupo(this.authService.getUsuarioLogado().grupo).subscribe({
      next: res => this.perfis = res
    });
  }

  cancelar() { this.dialog.close(); }

  filtrar() { this.dialog.close(this.filtro); }
}
